import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { useState, FC } from "react";
import styled, { css } from "styled-components";

import { AppsFlyerQRCode } from "@faire/retailer/icons/AppsFlyerQRCode/AppsFlyerQRCode";

interface IProps {
  backgroundColor: string;
  badge: React.ReactNode;
  qrCodeUrl?: string;
  qrCodeContainerWidth: number;
  qrCodePadding: number;
  trackingFunctionOnHover?: () => void;
}

export const MobileBadge: FC<IProps> = ({
  backgroundColor,
  badge,
  qrCodeUrl,
  qrCodeContainerWidth: qrCodeWidth,
  qrCodePadding,
  trackingFunctionOnHover,
}) => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const showQRCode = useViewport().isTabletAndAbove && isMouseOver;

  const setIsMouseOverAndTrack = () => {
    setIsMouseOver(true);
    if (trackingFunctionOnHover) {
      trackingFunctionOnHover();
    }
  };

  return (
    <Container
      $backgroundColor={backgroundColor}
      $showQRCode={showQRCode}
      onMouseOver={setIsMouseOverAndTrack}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      {badge}
      {showQRCode ? (
        <QRCodeContainer $width={qrCodeWidth} $padding={qrCodePadding}>
          <AppsFlyerQRCode
            qrCodeWidth={
              // container width minus padding on both sides
              qrCodeWidth - 2 * qrCodePadding
            }
            fallbackQrCodeUrl={qrCodeUrl}
          />
        </QRCodeContainer>
      ) : null}
    </Container>
  );
};

const Container = styled.div<{
  $backgroundColor: string;
  $showQRCode?: boolean;
}>`
  ${({ $showQRCode, $backgroundColor }) =>
    $showQRCode
      ? css`
          background: ${$backgroundColor};
          border-radius: ${getSpacing("1x", "1x", 0, 0)};
        `
      : ""}
`;

const QRCodeContainer = styled.div<{
  $width: number;
  $padding: number;
}>`
  ${({ $width, $padding }) => css`
    position: absolute;
    /* to prevent some footer elements to overlay on top of the QR code */
    z-index: 1;
    background-color: ${Core.surface.default};
    width: ${getSpacing($width)};
    border-radius: ${getSpacing(0, 0, "1x", "1x")};
    padding: ${getSpacing($padding)};
  `}
`;
